// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__Tl7ih","innerContainer":"style_innerContainer__evpOB","goldenLogo":"style_goldenLogo__AoDPV"};